import { useAppSelector } from 'redux/hooks';

import { SectionType, TabWrap } from 'sections/TabWrap';
import { ZoneList } from 'sections/ZoneList';

export function Sent(): React.ReactElement {
  const zones = useAppSelector((state) => state.currentUser.zones);

  const sections: SectionType[] = [
    {
      id: 1,
      content: <ZoneList items={zones} />,
    },
  ];

  return <TabWrap sections={sections} />;
}
